<template>
  <div id="contact_form" class="flex w-screen h-auto">
    <div class="md:pt-48 w-screen m-32">
      <div class="w-full md:max-w-xl p-10 bg-white shadow-2xl rounded-lg opacity-75 md:opacity-100">
        <h1 class="text-5xl font-bold mb-6 font-display">Help us help you with your vision</h1>

        <form class="form" action="">
          <div class="w-full md:w-1/2">
            <h2 class="form-heading font-text">Basic info</h2>

            <TextInput
              name="name"
              placeholder="Name"
            />
            <TextInput
              name="email"
              placeholder="Email"
            />
            <TextInput
              name="project_description"
              placeholder="Project Description"
            />
          </div>

          <h2 class="form-heading text-2xl font-display pt-10">What do you need?</h2>

          <div id="checkboxes" class="content">
            <div class="checkboxdiv">
              <label for="website"><p>Website</p></label>
              <label class="check">
                <input name="website" id="website" type="checkbox"/>
                <span></span>
              </label>
            </div>

            <div class="checkboxdiv">
              <label for="consulting"><p>Consulting</p></label>
              <label class="check">
                <input name="consulting" id="consulting" type="checkbox"/>
                <span></span>
              </label>
            </div>

            <div class="checkboxdiv">
              <label for="app"><p>App</p></label>
              <label class="check">
                <input name="app" id="app" type="checkbox"/>
                <span></span>
              </label>
            </div>

            <div class="checkboxdiv">
              <label for="others"><p>Others</p></label>
              <label class="check">
                <input name="others" id="others" type="checkbox"/>
                <span></span>
              </label>
            </div>

            <div class="checkboxdiv">
              <label for="design"><p>Design</p></label>
              <label class="check">
                <input name="design" id="design" type="checkbox"/>
                <span></span>
              </label>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../assets/css/index/contact_form.css';
  import TextInput from '../../components/input/TextInput';

  export default {
    name: 'ContactForm',
    components: {TextInput}
  }
</script>
